import type { AnswerProfile } from './answer-profile.type.ts';

export interface AnswerProfileExtension extends AnswerProfile {}
export class AnswerProfileExtension {
  // ── Computed Properties ──
  get hasExpiredRecertification() {
    if (!this.recertifiedIncomeAt) {
      return false;
    }

    const approxTenMonthsInMilliseconds = 31556952000 * (5 / 6);
    const todayInMilliseconds = new Date().getTime();
    const recertifiedAtInMilliseconds = new Date(this.recertifiedIncomeAt).getTime();
    const elapsedMilliseconds = todayInMilliseconds - recertifiedAtInMilliseconds;
    return elapsedMilliseconds >= approxTenMonthsInMilliseconds;
  }
}

const Registration = {
  kind: 'object',
  name: 'answer-profile',
  features: AnswerProfileExtension,
};
export default Registration;
